import { DomainCheckResults } from '@/core/ryanada'
import { DomainViewModel } from '@/view-models'
import { DomainResultDTO } from '@orderForm/core'

export class BulkDomainSearchDomainResultView {
  private submitBtn: HTMLButtonElement
  private domain: string
  private checkout = false
  private readonly viewModel: DomainViewModel
  private readonly TOKEN: string

  constructor(
    el: HTMLElement,
    domainInfo: DomainCheckResults,
    viewModel: DomainViewModel,
    token: string
  ) {
    // Assign
    this.TOKEN = token
    this.viewModel = viewModel

    // init
    const domainEl = el.querySelector<HTMLSpanElement>('.js-domain')
    const extensionEl = el.querySelector<HTMLSpanElement>('.js-extension')
    const priceEl = el.querySelector<HTMLSpanElement>('.js-price')
    const submitBtn = el.querySelector<HTMLButtonElement>(
      '.js-domain-search__bulk-result-btn'
    )

    // Handle Null Errors
    if (!domainEl) {
      throw new Error(
        'BulkDomainSearchDomainResultView: domain span el is null'
      )
    }
    if (!extensionEl) {
      throw new Error(
        'BulkDomainSearchDomainResultView: extension span el is null'
      )
    }
    if (!priceEl) {
      throw new Error('BulkDomainSearchDomainResultView: price span el is null')
    }
    if (!submitBtn) {
      throw new Error('BulkDomainSearchDomainResultView: submitBtn el is null')
    }

    // Assign
    this.domain = domainInfo.domainName
    this.submitBtn = submitBtn

    // Populate El
    domainEl.textContent = domainInfo.sld
    extensionEl.textContent = `.${domainInfo.tld}`
    priceEl.textContent = domainInfo.shortestPeriod.register

    // Label Button
    if (domainInfo.isAvailable && domainInfo.isPremium) {
      submitBtn.classList.add('premium')
      submitBtn.querySelector('.premium')?.classList.remove('hidden')
    }

    if (domainInfo.isAvailable && !domainInfo.isPremium) {
      submitBtn.querySelector('.to-add')?.classList.remove('hidden')
    }

    if (!domainInfo.isAvailable) {
      submitBtn.classList.add('unavailable')
      submitBtn.querySelector('.unavailable')?.classList.remove('hidden')
    }

    if (domainInfo.isAvailable) {
      submitBtn.addEventListener('click', (e) => {
        void this.onClick.bind(this)(e)
      })
    }
  }

  private onClick = async (e: Event): Promise<void> => {
    e.preventDefault()

    // Add Domain in not checked out
    if (!this.checkout) {
      this.showLoading()
      this.hideAddToCartText()

      const dto = new DomainResultDTO(this.domain)

      const formData = new FormData()
      formData.append('a', 'addToCart')
      formData.append('token', this.TOKEN)
      formData.append('domain', dto.name)

      const data = await this.viewModel.addToCartSingle(formData)

      this.hideLoading()
      this.checkout = true

      if (data.result === 'added') {
        this.showSuccessText()
        return
      }

      this.showFailureText()
      return
    }

    // Handle Checkout
    location.replace('cart.php?a=confdomains')
  }

  private getLoaderEl(): HTMLElement {
    const loader = this.submitBtn.querySelector<HTMLElement>('.loading')

    if (!loader) {
      throw new Error('BulkDomainSearchDomainResultView: .loading el is null')
    }
    return loader
  }

  private getAddToCartTextEl(): HTMLElement {
    const el = this.submitBtn.querySelector<HTMLElement>('.to-add')

    if (!el) {
      throw new Error(
        'BulkDomainSearchDomainResultView: AddToCartText el is null'
      )
    }
    return el
  }

  private getSuccessTextEl(): HTMLElement {
    const el = this.submitBtn.querySelector<HTMLElement>('.added')

    if (!el) {
      throw new Error(
        'BulkDomainSearchDomainResultView: AddToCartText el is null'
      )
    }
    return el
  }

  private getFailureTextEl(): HTMLElement {
    const el = this.submitBtn.querySelector<HTMLElement>('.unavailable')

    if (!el) {
      throw new Error(
        'BulkDomainSearchDomainResultView: AddFailedText el is null'
      )
    }
    return el
  }

  private showLoading(): void {
    const loader = this.getLoaderEl()
    loader.classList.remove('hidden')
  }

  private hideLoading(): void {
    const loader = this.getLoaderEl()
    loader.classList.add('hidden')
  }

  private showAddToCartText(): void {
    const text = this.getAddToCartTextEl()
    text.classList.remove('hidden')
  }

  private hideAddToCartText(): void {
    const text = this.getAddToCartTextEl()
    text.classList.add('hidden')
  }

  private showSuccessText(): void {
    const text = this.getSuccessTextEl()
    text.classList.remove('hidden')
  }

  private hideSuccessText(): void {
    const text = this.getSuccessTextEl()
    text.classList.add('hidden')
  }

  private showFailureText(): void {
    const text = this.getFailureTextEl()
    text.classList.remove('hidden')
  }

  private hideFailureText(): void {
    const text = this.getFailureTextEl()
    text.classList.add('hidden')
  }
}
